"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var propsFilter_1 = require("../../library/propsFilter");
var SharkMorphContext_1 = require("../../providers/SharkMorphContext");
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.parseCol = function (col) {
            if (typeof col === 'undefined') {
                return col;
            }
            return col.toString().replace('.', '-');
        };
        return _this;
    }
    Item.prototype.getColClassNames = function () {
        var _this = this;
        return Object.keys(this.props)
            .filter(function (key) { return Item.classMap[key]; })
            .map(function (key) {
            return typeof _this.props[key] === 'boolean'
                ? Item.classMap[key]
                : "".concat(Item.classMap[key], "-").concat(_this.parseCol(_this.props[key]));
        });
    };
    Item.prototype.getHideClassNames = function () {
        if (!this.props.hides) {
            return {};
        }
        return this.props.hides.reduce(function (c, v) {
            var _a;
            return (__assign(__assign({}, c), (_a = {}, _a["hide-".concat(v)] = true, _a)));
        }, {});
    };
    Item.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('flex-view-item', this.props.className, this.getColClassNames(), this.getHideClassNames(), { 'flex-view-item-grow': this.props.grow ? true : false }), css: (0, react_1.css)(this.props.style), onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave, onClick: this.props.onClick }, (0, propsFilter_1.getAllDataProps)(this.props, this.context), { children: this.props.children })));
    };
    Item.contextType = SharkMorphContext_1.SharkMorphContext;
    Item.classMap = {
        xs: 'col-xs',
        sm: 'col-sm',
        hs: 'col-hs',
        hm: 'col-hm',
        md: 'col-md',
        lg: 'col-lg',
        xl: 'col-xl',
        xsOffset: 'col-xs-offset',
        smOffset: 'col-sm-offset',
        hsOffset: 'col-hs-offset',
        hmOffset: 'col-hm-offset',
        mdOffset: 'col-md-offset',
        lgOffset: 'col-lg-offset',
        xlOffset: 'col-xl-offset',
    };
    return Item;
}(React.PureComponent));
exports.Item = Item;
//# sourceMappingURL=Item.js.map